import styled from 'styled-components';
import { Card } from 'antd';

export const HeroSection = styled.section`
  position: relative;
  margin-bottom: 48px;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: 
    linear-gradient(to right, rgba(241, 86, 55, 0.85), rgba(251, 168, 64, 0.85)),
    url('https://athletechnews.com/wp-content/uploads/2022/04/ORANGETHEORY-flagship-NYC-location-news.jpg');
    background-size: cover;
    background-position: center;
    z-index: 1;
  }
`;

export const HeroContent = styled.div`
  position: relative;
  z-index: 2;
  padding: 48px 0;
  min-height: 400px;
  display: flex;
  align-items: center;
  .container {
    width: 100%;
  }
`;

export const ImageContainer = styled.div`
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  
  img {
    width: 100%;
    height: 350px;
    object-fit: cover;
  }
`;

export const SearchCard = styled(Card)`
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  
  .ant-card-body {
    padding: 32px;
  }
`;

export const EqualCol = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 350px;
  width: 100%;
`;